import { useState } from "react";
import { server } from "../../config";
import ProductSmallTile from "../product-tile/product-small-tile";
import { IProduct } from "../../model/product";
import Product from "../product-page-content/product";
import styles from "./front-products.module.css";
export default function FrontProducts() {
  const [sup, setSup] = useState<IProduct[] | null>(null);
  const [garmin, setGarmin] = useState<IProduct[] | null>(null);
  const [electricBikes, setElectricBikes] = useState<IProduct[] | null>(null);
  const [lasteBikes, setLastebikes] = useState<IProduct[] | null>(null);
  const [diving, setDiving] = useState<IProduct[] | null>(null);
  const [fetchedRandomProducts, setFetchedRandomProducts] = useState(false);

  if (!fetchedRandomProducts) {
    setFetchedRandomProducts(true);
    var funcs$ = [fetch(`${server}/api/getFrontProducts`)];
    Promise.all(funcs$)
      .then(async (response) => {
        setFetchedRandomProducts(true);
        let frontProducts = await response[0].json();
        setGarmin(
          shuffleArray(
            frontProducts.filter(
              (p: IProduct) => p.name.indexOf("Garmin") > -1,
            ),
          ),
        );
        setDiving(
          shuffleArray(
            frontProducts.filter(
              (p: IProduct) => p.affiliate === "DIVING2000",
            ),
          ),
        );        
        setSup(
          shuffleArray(
            frontProducts.filter(
              (p: IProduct, i: number) =>
                p.catalogName.toLowerCase() === "sup brett",
            ),
          ).splice(0, 4),
        );
        setElectricBikes(
          shuffleArray(
            frontProducts.filter(
              (p: IProduct, i: number) =>
                p.catalogName.indexOf("Elsykler") > -1
            ),
          ).splice(0, 4),
        );
        setLastebikes(
          shuffleArray(
            frontProducts.filter(
              (p: IProduct, i: number) =>
                p.catalogName.indexOf("lastesykkel") > -1
            ),
          ).splice(0, 4),
        );       
      })
      .catch((error) => {
        console.error(error);
        setFetchedRandomProducts(true);
      });
  }

  function shuffleArray(array: IProduct[]) {
    for (var i = array.length - 1; i >= 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  return (
    <>

      <section className={styles.expandedFrontSection}>
        <h2>Lastesykkel</h2>
        <p style={{padding: '0 16px 0 16px', fontSize: '1.2em', textAlign: 'left', lineHeight: '1.5'}}>
            <strong>Lastesykkel er fremtidens løsning for smart og bærekraftig transport.</strong> Stadig flere velger lastesykkel som et praktisk alternativ til bil - enten det gjelder barnelevering, handling eller jobb på farten. 
            Med stabile kjøreegenskaper, god plass og mulighet for elektrisk hjelp, får du friheten til å transportere mer - helt uten kø, bensin eller parkeringstress. Vi har samlet et bredt utvalg fra flere merker, slik at 
            du enkelt kan finne lastesykkelen som passer ditt behov!
        </p>
        <p style={{padding: '0 16px 0 16px', fontSize: '1.2em', textAlign: 'left', lineHeight: '1.5'}}>
          Klikk her for å lese vår <a href="/produkter/lastesykkel">komplette guide til lastesykler</a> - perfekt for familier, bedrifter og alle som ønsker en grønnere hverdag.
        </p>        
        {lasteBikes && lasteBikes.length > 0 && 
          <div className={styles.productDetailsWrapper}>
            <Product
            product={lasteBikes![0]}
            usedInFront={true}
          />
          </div>
        }
        <br/>
        {lasteBikes?.map &&
          lasteBikes?.map((p) => (
            <ProductSmallTile
              detailsPath={`/produkter/${p.brand}`}
              product={p}
              size="normal"
              key={p._id.toString()}
            />
        ))}
      </section>
      <br />  
      <section className={styles.expandedFrontSection}>
        <h2>EL - sykkel</h2>
        <p style={{padding: '0 16px 0 16px', fontSize: '1.2em', textAlign: 'left', lineHeight: '1.5'}}>
          <strong>Elsykkel er mer populært enn noensinne - og det skjønner vi godt.</strong> Stadig flere velger elsykkel som et smart og miljøvennlig alternativ til bilen 
          i hverdagen. Med kraftige, moderne batterier som gir lang rekkevidde og rask lading, får du friheten til å komme 
          deg rundt i byen - uten kø, stress eller svette. Vi samler elsykler fra flere leverandører, slik at du kan finne den elsykkelen som passer din livsstil!
        </p>        
        {electricBikes?.map &&
          electricBikes?.map((p) => (
            <ProductSmallTile
              detailsPath={`/produkter/${p.brand}`}
              product={p}
              size="normal"
              key={p._id.toString()}
            />
          ))          
        }
        {electricBikes && electricBikes.length > 0 && 
          <div className={styles.productDetailsWrapper}>
            <Product
            product={electricBikes![0]}
            usedInFront={true}
          />
          </div>
        }
      </section>
      <br />  
      <section className={styles.expandedFrontSection}>
        <h2>SUP (Stand up paddle) - brett</h2>
        <p style={{padding: '0 16px 0 16px', fontSize: '1.2em', textAlign: 'left', lineHeight: '1.5'}}>
          <strong>SUP-board gir deg friheten til å utforske vannet på en ny og morsom måte.</strong> Stand up paddling har blitt en av de mest populære vannaktivitetene -
           og det er ikke uten grunn. SUP passer for alle aldre og ferdighetsnivåer, enten du vil ha rolig trening på stille vann, leke i bølger eller bare nyte naturen fra et nytt perspektiv.
          Vi har samlet et bredt utvalg av SUP-brett for både nybegynnere og erfarne padlere, slik at du finner det brettet som passer dine behov og din sommer.
        </p>        
        {sup?.map &&
          sup?.map((p) => (
            <ProductSmallTile
              detailsPath={`/produkter/${p.brand}`}
              product={p}
              size="normal"
              key={p._id.toString()}
            />
          ))          
        }
        {sup && sup.length > 0 && 
          <div className={styles.productDetailsWrapper}>
            <Product
            product={sup![0]}
            usedInFront={true}
          />
          </div>
        }
      </section>          
      <br />     
      <h2>Garmin treningsklokke</h2>
      <section>
        {garmin?.map &&
          garmin?.map((p) => (
            <ProductSmallTile
              detailsPath={`/produkter/${p.brand}`}
              product={p}
              size="normal"
              key={p._id.toString()}
            />
          ))}
      </section>
      <br />
      <h2>Dykkerutstyr</h2>
      <section>
        {diving?.map &&
          diving?.map((p) => (
            <ProductSmallTile
              detailsPath={`/produkter/${p.brand}`}
              product={p}
              size="normal"
              key={p._id.toString()}
            />
          ))}
      </section>
      <br />      
      <section>
        <div className="hideInMobile hideOnPad ad">
          <br />
          <a
            href="https://www.partner-ads.com/no/klikbanner.php?partnerid=30465&bannerid=87165"
            target="_blank"
            rel="nofollow noopener"
          >
            {" "}
            <img
              src="https://www.partner-ads.com/no/visbanner.php?partnerid=30465&bannerid=87165"
              alt="HydroForce SUP"
            />
          </a>
        </div>
      </section>
    </>
  );
}